module.exports = __webpack_public_path__ + "img/linked-bank-account.b07f2e74.svg";